
class DataItem {
  key: String;
  label: String;
  disabled: boolean;

  constructor(key = "", label = "") {
    this.key = key;
    this.label = label;
  }
}

class PageInfo {
  total: number;
  current: number;
  pageSize: number;

  constructor(total = 0, current = 1) {
    this.current = current;
    this.total = total;
    this.pageSize = 20;
  }
}

import { Component, Prop, BaseMixins } from "@/lib";

@Component({ name: "multiple-user-select-modal" })
export default class MultipleUserSelectModal extends BaseMixins {
  /* 是否显示 */
  @Prop({ type: Boolean, default: false }) show: boolean;

  /* 点击确定按钮时，确定按钮是否显示 loading 状态，开启则需手动设置value来关闭对话框 */
  @Prop({ type: Boolean, default: false }) loading: boolean;

  @Prop({ type: Boolean, default: false }) queryLoading: boolean;

  modalData: any = {
    availableUserList: Array<DataItem>(),
    currentPageData: Array<DataItem>(),
    filterName: "",
    isShow: false,
    queryPage: new PageInfo(),
    allUserList: Array<DataItem>(),
    currentSelectedKeys: Array(),
  };

  async created() {
    // //获取全部用户
    // let allUsers = await this.$store.dispatch("system/user/getUserSelectList");
    // if (allUsers) {
    //   this.modalData.allUserList = allUsers.map((item) => new DataItem(item.value, `${item.displayText}`));
    // } else {
    //   this.modalData.allUserList = new Array<DataItem>();
    // }
  }

  //防抖
  Debounce(func, wait = 500, immediate = false) {
    let timeout;
    // 清除定时器
    if (timeout !== null) clearTimeout(timeout);
    // 立即执行，此类情况一般用不到
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(function() {
        timeout = null;
      }, wait);
      if (callNow) typeof func === "function" && func();
    } else {
      // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
      timeout = setTimeout(function() {
        typeof func === "function" && func();
      }, wait);
    }
  }

  async filterUser(query) {
    this.$nextTick(() => {
      console.log("filterUser", query);
      this.Debounce(this.queryUser(query));
    });
  }

  async queryUser(query) {
    if (query) {
      this.modalData.queryLoading = true;
      let queryStr = query.replace(/\(/g, "\\(").replace(/\)/g, "\\)");
      let reg = new RegExp(queryStr);
      let matchedUserList = this.modalData.allUserList.filter((x) => x.label.match(reg));
      //let selectedList = this.getSelectedData();

      //this.modalData.availableUserList = matchedUserList.concat(selectedList);
      this.modalData.availableUserList = matchedUserList;
      this.modalData.queryPage.total = this.modalData.availableUserList.length;
      //加载首页
      this.changePageIndex(1);

      console.log("filter - currentpage", this.modalData.currentPageData);

      this.modalData.queryLoading = false;
    }
  }

  getSelectedData() {
    if (this.modalData.currentSelectedKeys && this.modalData.currentSelectedKeys.length > 0) {
      let selectedList = this.modalData.allUserList.filter((item) => this.modalData.currentSelectedKeys.includes(item.key));
      return selectedList;
    } else {
      return new Array<DataItem>();
    }
  }

  getPageData() {
    let pageList = [];
    let startIndex = this.modalData.queryPage.current - 1;
    let length = this.modalData.queryPage.pageSize;
    pageList = this.modalData.availableUserList.slice(startIndex * length, (startIndex + 1) * length);

    let selectedList = this.getSelectedData();

    return pageList.concat(selectedList);
  }

  changePageSize(value) {
    this.modalData.queryPage.pageSize = value;
    this.modalData.currentPageData = this.getPageData();
  }

  changePageIndex(value) {
    this.modalData.queryPage.current = value;
    this.modalData.currentPageData = this.getPageData();
  }

  inputChange(textInput) {
    this.filterUser(this.modalData.filterName);
  }
  onOk() {
    this.modalData.isShow = false;
    let userData = this.getSelectedData();
    this.$emit("set-ok", this.modalData.currentSelectedKeys, userData);
  }

  onCancel() {
    this.modalData.isShow = false;
    this.$emit("on-cancel");
  }

  onChange(newTargetKeys) {
    console.log("selected", newTargetKeys);

    this.modalData.currentSelectedKeys = Array.from(new Set(newTargetKeys));
  }

  async getAllUser() {
    //获取全部用户
    let allUsers = await this.$store.dispatch("system/user/getUserSelectList");
    if (allUsers) {
      this.modalData.allUserList = allUsers.map((item) => new DataItem(`${item.value}`, `${item.displayText}`));
    } else {
      this.modalData.allUserList = new Array<DataItem>();
    }

    this.modalData.availableUserList = this.modalData.allUserList;
    this.modalData.queryPage.total = this.modalData.allUserList.length;

    this.changePageIndex(1);
  }

  open(defaultSelectedKeys) {
    console.log("openned", defaultSelectedKeys);
    this.modalData.filterName = "";
    this.getAllUser();
    this.modalData.currentSelectedKeys = defaultSelectedKeys ? defaultSelectedKeys : [];
    this.modalData.isShow = true;
  }
}
